module.exports = __webpack_public_path__ + "static/company-location-efc9da98f326ffb7947b846dde56172b.jpg";